import { render, staticRenderFns } from "./PostCard.vue?vue&type=template&id=1340eb88&scoped=true&"
import script from "./PostCard.vue?vue&type=script&lang=ts&"
export * from "./PostCard.vue?vue&type=script&lang=ts&"
import style0 from "./PostCard.vue?vue&type=style&index=0&id=1340eb88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1340eb88",
  null
  
)

export default component.exports